import { useQuery, useMutation, useInfiniteQuery } from "react-query";
import axios from "axios";
import { getApiPath } from "../../utils/variables";
import { authHeader } from "../store";

export function updateTags(tags) {
  let tagIdList = "";
  if (tags?.length > 0) {
    tags.forEach((tag) => {
      tagIdList += `id=${tag}&`;
    });
  }
  if (tagIdList) {
    return axios.put(
      `${getApiPath()}/tags/exactMatch?${tagIdList}`,
      {},
      { headers: authHeader() }
    );
  } else {
    return Promise.reject("No tags to update");
  }
}
export function useUpdateTags() {
  return useMutation((tags) => updateTags(tags), {});
}

export function getPaginatedTags(data, { pageParam }) {
  const { ignore, term, meaning, includeConferences, maxResult, nocache } =
    data;
  const url = `${getApiPath(false)}/tags`;
  return axios.get(url, {
    params: {
      ignore,
      term,
      meaning,
      includeConferences,
      maxResult,
      nocache,
      pageNum: pageParam,
    },
  });
}

export function useGetPaginatedTags(data, { getNextPageParam }) {
  return useInfiniteQuery(
    ["paginatedTags", data],
    ({ pageParam = 0 }) => getPaginatedTags(data, { pageParam }),
    {
      getNextPageParam,
      refetchOnMount: false,
      cacheTime: 300000,
    }
  );
}

export function getTopConferences(data) {
  const url = `${getApiPath(false)}/tags/topConferences`;
  return axios.get(url, { params: data });
}

export function useTopConferences(data) {
  return useQuery(["tagsTopConferences", data], () => getTopConferences(data), {
    refetchOnMount: false,
    cacheTime: 300000,
  });
}

export function getPaginatedTopConferences(data, { pageParam }) {
  const { term, maxResult } = data;
  const url = `${getApiPath(false)}/tags/topConferences`;
  return axios.get(url, {
    params: {
      term,
      maxResult,
      pageNum: pageParam,
    },
  });
}

export function useGetPaginatedTopConferences(data, { getNextPageParam }) {
  return useInfiniteQuery(
    ["paginatedTopConferences", data],
    ({ pageParam = 0 }) => getPaginatedTopConferences(data, { pageParam }),
    {
      getNextPageParam,
      refetchOnMount: false,
      cacheTime: 300000,
    }
  );
}

export function useGetTag({ id }) {
  return useQuery(
    ["tag", id],
    () => {
      const url = `${getApiPath(false)}/tag/${id}`;
      return axios.get(url, {});
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!id,
    }
  );
}

export function useCountTags({ params }) {
  return useQuery(
    ["tagCount", params],
    () => {
      const url = `${getApiPath(false)}/tags/count`;
      return axios.get(url, { params });
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
    }
  );
}

export function useGetReferredHandlesCount(params) {
  return useQuery(
    ["referredHandlesCount", params],
    () => {
      const url = `${getApiPath(false)}/tags/referredHandlesCount`;
      return axios.get(url, { params });
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!params?.tagId,
    }
  );
}

export function useGetTagDols(params) {
  return useQuery(
    ["tagDols", params],
    () => {
      params;
      const url = `${getApiPath(false)}/tags/dols`;
      return axios.get(url, { params });
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!params?.tagId,
    }
  );
}

export function useGetTagDolsByViews(params) {
  return useQuery(
    ["tagDolsByViews", params],
    () => {
      params;
      const url = `${getApiPath(false)}/tags/dolsByViews`;
      return axios.get(url, { params });
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!params?.tagId,
    }
  );
}

export function useGetTagCountrySegmentedSummary(params) {
  return useQuery(
    ["countrySegmentedSummary?", params],
    () => {
      params;
      const url = `${getApiPath(false)}/tags/countrySegmentedSummary`;
      return axios.get(url, { params });
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!params?.tagId,
    }
  );
}

export function useGetTagOverallStats(params) {
  return useQuery(
    ["overallStats", params],
    () => {
      params;
      const url = `${getApiPath(false)}/tags/overallStats`;
      return axios.get(url, { params });
    },
    {
      refetchOnMount: false,
      cacheTime: 300000,
      enabled: !!params?.tagId,
    }
  );
}
